export { default } from '@triptyk/ember-utils/services/fetch';
